"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var snarkdown_1 = require("snarkdown");
var VehicleDetailsDisclaimer = function () {
    var intl = react_intl_1.useIntl();
    var translationId = 'trans__checkout__vehicle_details__disclaimer';
    var content = intl.formatMessage({ id: translationId });
    if (content === translationId) {
        return null;
    }
    return (<core_1.Box mt={'30px'}>
      <core_1.Typography variant={'subtitle1'} dangerouslySetInnerHTML={{ __html: snarkdown_1.default(content) }}/>
    </core_1.Box>);
};
exports.default = VehicleDetailsDisclaimer;
